import { useQueryClient } from '@tanstack/react-query';
import { API_QUERY_KEYS } from '../../../../consts';

/**
 * @deprecated Use `useDocumentCacheManager` from `entities/document/api/hooks` instead.
 */
export const useDocumentCache = () => {
  const queryClient = useQueryClient();

  const refetchAllDocumentsQueries = async () => {
    const queries = queryClient.getQueriesData({});

    // refetch all documents queries
    queries.forEach((query: any) => {
      if ([API_QUERY_KEYS.documents, 'packages'].includes(query[0][0])) {
        queryClient.refetchQueries(query[0]);
      }
    });
  };

  const invalidateDocumentCache = (documentIds: number[]) => {
    documentIds.forEach(id => {
      queryClient.invalidateQueries([
        API_QUERY_KEYS.document,
        { documentId: id },
      ]);
    });
  };

  return {
    refetchAllDocumentsQueries,
    invalidateDocumentCache,
  };
};
